export type CatalogSearchRouteContext =
    | { type: 'global' }
    | { type: 'property-catalog'; isInventory: boolean };

export const getCatalogSearchRouteContext = (
    pathname: string,
): CatalogSearchRouteContext | null => {
    if (pathname.includes('/orders/add-items/marketplace')) {
        return { type: 'global' };
    }

    if (pathname.startsWith('/orders/add-items/categories')) {
        return { type: 'property-catalog', isInventory: false };
    }

    const catalogMatch = pathname.match(
        /^\/(?:catalog|properties\/[^/]+\/catalog)(?:\/(.*))?$/,
    );

    if (!catalogMatch) {
        return null;
    }

    // Normalize: for /catalog/:propertyId/... the first segment is propertyId
    // for legacy /properties/:id/catalog/... the capture is already after catalog/
    let catalogPath = catalogMatch[1] ?? '';

    if (pathname.startsWith('/catalog/')) {
        // Drop propertyId segment: /catalog/:propertyId/(rest)
        const segments = catalogPath.split('/');
        catalogPath = segments.slice(1).join('/');
    }

    if (catalogPath.startsWith('global')) {
        return { type: 'global' };
    }

    if (catalogPath.startsWith('inventory')) {
        return { type: 'property-catalog', isInventory: true };
    }

    return { type: 'property-catalog', isInventory: false };
};

export const isCatalogSearchRoute = (pathname: string): boolean =>
    getCatalogSearchRouteContext(pathname) !== null;
